import { call, put } from 'redux-saga/effects';
import { ACTIONS, APIS } from '../../_config';
import { CallApi } from '../api/callApi';



export function*  getChecklistTypes (action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.CHECKLIST.GET_CHECKLIST_TYPES, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
  };
 
  export function*  getChecklistCode (action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.CHECKLIST.GET_CHECKLIST_CODE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
  };
 
  export function*  getChecklists (action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.CHECKLIST.GET_CHECKLISTS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
  };
  export function*  getChecklistByID (action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.CHECKLIST.GET_CHECKLIST_BY_ID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
  };

 
  export function*  saveChecklist (action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.CHECKLIST.SAVE_CHECKLIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
  };

 
  export function*  deleteChecklist (action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.DELETE, APIS.CHECKLIST.DELETE_CHECKLIST+"?CheckListID="+data.CheckListID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
  };
  
 
  export function*  getChecklistInputTypes (action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.CHECKLIST.GET_CHECKLIST_INPUT_TYPES, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
  };
  
 
  export function*  saveChecklistTask (action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.CHECKLIST.SAVE_CHECKLIST_TASK, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
  };
  

  export function*  saveCheckListTasksAssetMapping (action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.CHECKLIST.SAVE_CHECKLIST_TASKS_ASSET_MAPPING, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
  };

  export function*  getAssetsByChecklist (action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.CHECKLIST.GET_ASSETS_BY_CHECKLIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
  };
  export function*  duplicateChecklist (action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.CHECKLIST.DUPLICATE_CHECKLIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
  };







 

 



